import { type LalSegmentApi, lalSegmentStatus } from '@openx/types/segments.ts';

export const isLalSegmentInProcessing = (lalSegment: LalSegmentApi) => {
  if (!lalSegment.status) {
    return false;
  }

  return lalSegmentStatus.PROCESSING === lalSegment.status.toLowerCase();
};
